module.exports = __webpack_public_path__ + "static/media/carta_10.3866dc71.jpg";